import chameleon from '@chamaeleonidae/chmln'

const CHAMELEON_APP_ID = import.meta.env.VITE_CHAMELEON_APP_ID
let initialized = false

export function initChameleon(): void {
  if (initialized) return
  if (!CHAMELEON_APP_ID || typeof CHAMELEON_APP_ID !== 'string') return
  chameleon.init(CHAMELEON_APP_ID, { fastUrl: 'https://fast.chameleon.io/' })
  initialized = true
}

export function trackChameleon(event: string): void {
  if (!initialized) return
  chameleon.track(event)
}

export function showChameleonExperience(
  experienceId: string,
  options?: { kind?: 'demo' | 'tour' },
): void {
  if (!initialized) return
  // The npm wrapper @chamaeleonidae/chmln only exports init/identify/track.
  // show() lives on the runtime global window.chmln installed by chameleon.init().
  // For Demos, pass { kind: 'demo' } — Tours are the implicit default.
  window.chmln?.show(experienceId, options)
}

export function identifyChameleon(
  uid: string,
  traits: {
    email?: string
    name?: string
    account_uuid?: string | null
    account_name?: string | null
    hub_uuid?: string
  },
): void {
  if (!initialized) return
  chameleon.identify(uid, traits)
}
